import { PostSpecificItem } from "@libs/types/response"
import { deviceManager } from "../../device/device_manager"
import { SpecificItem, SpecificItemAction } from "@libs/types/enum"
import { dataProfileManage } from "@hid/snapshot/profile"

export const handleSetOrReadSpecificItem = async (data: PostSpecificItem) => {
    const config = dataProfileManage()
    if (data.Item == SpecificItem.DeadZone && data.Action == SpecificItemAction.Write) {

        if (!Array.isArray(data.Value) || data.Value.length != 2) {
            throw new Error("DeadZone value must be an array with 2 elements")
        }
        config.dataProfile.DeadZone1 = [Number(data.Value[0]), Number(data.Value[1])]
        config.save()
    }

    if(data.Item != SpecificItem.DeadZone && data.Action == SpecificItemAction.Write){
        config.dataProfile.Items.set(data.Item, data.Value)
        config.save()
    }

    const resp = await deviceManager.deviceDriver.setOrReadSpecificItem(data.Item, data.Action == SpecificItemAction.Write, data.Value)
    return resp
}

